import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagerService } from './_services/pager.service'
import { routes } from './news.routes';

// Template, menu
import {
  MenuComponent,
} from './menu';

import { NewsComponent } from './news.component';
import { ShippingTqComponent } from './shipping-tq';
import { HotNewsComponent } from './hotnews/hotnews.component';
import { NewsDetailsComponent } from './news-details/news-details.component'

console.log('`Detail` bundle loaded asynchronously');

@NgModule({
  declarations: [
    /**
     * Components / Directives/ Pipes
     */
    NewsComponent,
    ShippingTqComponent,
    HotNewsComponent,
    NewsComponent,
    NewsDetailsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
  ],
  providers: [
    PagerService
  ],
})
export class NewsModule {
  public static routes = routes;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/news/news.module.ts